module.exports = __webpack_public_path__ + "img/CRT_Sword-001.dd6d3b93.png";